import ButtonRow from 'lib/src/components/button/ButtonRow';
import LinkButton from '@components/button/LinkButton';
import DataCheck from 'lib/src/components/common/DataCheck';
import Table from 'lib/src/components/table/Table';
import { Column } from 'lib/src/types/table';
import { isEmpty } from 'lib/src/utils/generic';
import { AssessmentChallenge, Submission } from 'src/types/shared/Assessments';
import useFetchSubmissions from './hooks/useFetchSubmissions';

interface Props {
    assessmentChallenge: AssessmentChallenge;
}

const SubmissionsTable = ({ assessmentChallenge }: Props) => {
    const { submissions, isFetching, fetchError } = useFetchSubmissions(
        assessmentChallenge.id,
        true,
    );

    return (
        <DataCheck
            dataExists={!isEmpty(assessmentChallenge)}
            isFetching={isFetching}
            error={fetchError}
        >
            <Table columns={columns} rows={submissions} />
        </DataCheck>
    );
};

const columns: Column<Submission>[] = [
    {
        key: 1,
        heading: 'Company / Organisation name',
        getValue: row => row.companyName ?? '',
        searchable: true,
    },
    {
        key: 2,
        heading: 'Idea Summary',
        getValue: row => <p className="break-text">{row.ideaSummary || ''}</p>,
        searchable: true,
    },
    {
        key: 3,
        heading: '',
        getValue: row => (
            <ButtonRow alignment="right">
                <p className="flex-row align-center status">
                    {row.hasUserAssessed ? (
                        <>
                            <i className="far fa-check" />
                            <span>&nbsp;Entry assessed</span>
                        </>
                    ) : (
                        <>
                            <i className="far fa-times" />
                            <span>&nbsp;Not yet assessed</span>
                        </>
                    )}
                </p>
                <LinkButton
                    color="green"
                    icon="search"
                    href={`/assessments/submissions/submission/${row.id}`}
                >
                    View details
                </LinkButton>
                <LinkButton
                    color="yellow"
                    icon="pencil"
                    href={`/assessments/submissions/assessment/${
                        row.hasUserAssessed ? 'edit' : 'assess'
                    }/${row.id}`}
                >
                    {row.hasUserAssessed ? 'Edit assessment' : 'Begin assessment'}
                </LinkButton>
            </ButtonRow>
        ),
    },
];

export default SubmissionsTable;
